//

import S from './styles';

const Title = ({ title, children }) => <S.Title title={title}>{children}</S.Title>;

export default Title;
